// A Google Task that has a time shows up in Google Calendar, and the Calendar API
// hands it to Clarity as an ordinary event. The only thing marking it is the
// description Google writes into it: "Changes made to the title, description, or
// attachments will not be saved. To make edits, please go to:
// https://tasks.google.com/task/<id>" (seen on a real account, 2026-10-20).
// Clarity keeps it as an event (the sync engine only knows events) but labels it
// a Task, and shows a link to edit it in Google Tasks instead of that text.

const GOOGLE_TASK_LINK = /https:\/\/tasks\.google\.com\/task\/[A-Za-z0-9_-]+/;

export function isGoogleTaskEvent(ev) {
  return !!ev && GOOGLE_TASK_LINK.test(String(ev.description || ""));
}

export function googleTaskUrl(ev) {
  const m = String(ev?.description || "").match(GOOGLE_TASK_LINK);
  return m ? m[0] : "";
}
